export type NoteType = 'added' | 'removed' | 'updated';

export enum NoteTypes {
  ADDED = 'added',
  REMOVED = 'removed',
  UPDATED = 'updated',
}

export interface INote {
  section: string;
  summary: string;
  type: NoteType;
  id: string;
  isAIGeneratedUMC: boolean;
  isUserReviewed: boolean;
  sectionId: string;
}
